import { createContext, useContext } from "react";

type RadioButtonGroupContextValue = {
  isError: boolean;
  groupName?: string;
  orientation: "vertical" | "horizontal";
};

export const RadioButtonGroupContext = createContext<RadioButtonGroupContextValue>({
  isError: false,
  groupName: undefined,
  orientation: "vertical",
});

export const useRadioButtonGroupContext = () => useContext(RadioButtonGroupContext);
